import customAxios from "../api/interceptors";

export const clientKanbanService = (id:number, page= 1, per_page_count = 5, filter: string) => customAxios.get(`company/user/kanban?expand=manager,layers,next_step${id ? `&id=${id}` : ''}&per_page_count=${per_page_count}&page=${page}${filter}`)